import React from 'react'
import { requireAuthenticatedAgent } from '../../hoc/AuthenticatedComponent'
import Page from 'v5/client/newPropertyPage/NewPropertyPageRelay.bs'
import { provider as LoggedInAgent } from 'reason/common/UserSession/LoggedInAgent.bs'
import { withMainLayoutNoPadding } from '../../pagesComponents/MainApp'

const NewPropertyPage_ = () => {
  return (
    <LoggedInAgent>
      <Page />
    </LoggedInAgent>
  )
}

const NewPropertyPage = requireAuthenticatedAgent(NewPropertyPage_)

NewPropertyPage.getLayout = withMainLayoutNoPadding

export default NewPropertyPage
